/**
 * @version 1.0.1
 * @author 杨凤
 * @createTime:2021-6-3,
 * @copyright thunisoft fd
 * 面包屑导航
 */
export default {
    name: 'components-crumbs',
    props:{

        /**
         * #property
         *
         * @name    dataList
         * @cn      面包屑导航除首页之外的list
         * @group   数据{name:'',key:'',path:''}如果需要跳转才加path
         * @type    Array
         * @description 内容
         */
        dataList:{
            type: Array,
            default: function () {
                return [];
            },
            required: true
        }
    },
    data() {
        return {
            firstListItem:[{
                name:'首页',
                key:'index',
                path:'/index'
            }],
            breadNavList:[]
        };
    },
    created() {
        this.breadNavList = [...this.firstListItem, ...this.dataList];
    },
    watch: {
        dataList:{
            deep:true,
            handler(val) {
                this.breadNavList = [...this.firstListItem, ...val];
            }
        }
    },
    computed: {},
    methods: {
        clickNav(item) {
            if (item.path && !this.clickFalse) {
                this.$router.push({
                    path: item.path,
                    query: item.query || {}
                });
            }
            this.$emit('click', item);
        }
    }
};
